import { CommonModule } from '@angular/common';
import { Component, DestroyRef, inject, input, signal, WritableSignal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { catchError, EMPTY, finalize, tap } from 'rxjs';
import { FileDownloadModel } from 'src/app/models/api/fileDownload.model';
import { LabelsProviderPipe } from 'src/app/pipes/labels-provider/labels-provider.pipe';
import {
  PoliciesHttpService,
  RuleType,
} from 'src/app/services/httpServices/governance/policiesHttpService/policies-http.service';
import { HttpErrorHandlerService } from 'src/app/services/httpServices/httpErrorHandlerService/http-error-handler.service';

@Component({
  selector: 'app-policy-export',
  standalone: true,
  imports: [CommonModule, MatTooltipModule, LabelsProviderPipe, MatProgressSpinnerModule],
  templateUrl: './policy-export.component.html',
  styleUrl: './policy-export.component.scss',
})
export class PolicyExportComponent {
  public integrationId = input.required<string>();
  public policyId = input.required<string>();
  public violationsDataType = input.required<RuleType>();

  public waitingForFile: WritableSignal<boolean> = signal<boolean>(false);

  private readonly _policiesHttpService = inject(PoliciesHttpService);
  private readonly _httpErrorHandlerService = inject(HttpErrorHandlerService);
  private readonly _destroyRef = inject(DestroyRef);

  public exportToCSV(): void {
    this.waitingForFile.set(true);
    this._policiesHttpService
      .exportPolicyRules(this.integrationId(), this.policyId(), this.violationsDataType())
      .pipe(
        tap((response: FileDownloadModel) => window.open(response.fileUrl)),
        catchError((error) => {
          this._httpErrorHandlerService.handle(error);
          return EMPTY;
        }),
        finalize(() => this.waitingForFile.set(false)),
        takeUntilDestroyed(this._destroyRef)
      )
      .subscribe();
  }
}
